import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { ToastService } from "../../../_services/toast.service";
import { PlanningConfirmTransportService } from "../../../_services/planning-confirm-transport.service";
import { PlanningFilesService } from "../../../_services/planning-files.service";

declare var jQuery: any;

import "../../../../assets/semantic/semantic.min.js";
import { FormGroup, FormControl } from "@angular/forms";

@Component({
  selector: "client-planning-confirm-transport-modal",
  templateUrl: "./client-planning-confirm-transport-modal.component.html",
  styleUrls: ["./client-planning-confirm-transport-modal.component.css"],
})

export class ClientPlanningConfirmTransportModalComponent implements OnInit {
  
  @Output() updatePlanningState: EventEmitter<object> = new EventEmitter<object>();
  private planning_id: number;
  private planning_files: Array<Object> | null = null;
  private planning_files_attachments: Array<number> = [];
  private sendConfirmTransportLoading: boolean = false;

  confirm_transport_form = new FormGroup({
    planning_confirm_transport_free_text: new FormControl(),
    planning_confirm_transport_additional_recipients: new FormControl(),
  });

  constructor(
    private toast: ToastService, 
    private planningConfirmTransportService: PlanningConfirmTransportService,
    private planningFilesService: PlanningFilesService
  ) { }
  
  ngOnInit() {}
  
  handleFileCheckboxChange(event: any) {
    if (event.target.checked) {
      this.planning_files_attachments.push(event.target.attributes.planning_file_id.value);
    } else {
      this.planning_files_attachments = this.planning_files_attachments.filter(x => x != event.target.attributes.planning_file_id.value);
    }
  }

  // Get planning files
  getPlanningFiles(planning_id) {
    this.planningFilesService.getPlanningFiles(planning_id).subscribe(
      (response) => {
        //console.log("this.planningFilesService.getPlanningFiles response:", response);
        this.planning_files = response;
      },
      (error) => {
        console.log("this.planningFilesService.getPlanningFiles error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la récupération des documents du planning.`,
          false,
          "Récupération des documents"
        );
      }
    );
  }

  sendPlanningConfirmTransport(data) {
    if (data.planning_confirm_transport_additional_recipients && data.planning_confirm_transport_additional_recipients.trim().length) {
      const emails = data.planning_confirm_transport_additional_recipients.split(',');
      var emails_error: boolean;
      for (let email of emails)
        if (!this.isValidMail(email.trim())) emails_error = true;
      if (emails_error) {
        this.toast.error("Adresse email incorrecte dans le champ 'Destinataires complémentaires'.", false, "Confirmer le transport");
        return;
      }
    }

    this.sendConfirmTransportLoading = true;

    const body = {
      planning_id: this.planning_id,
      planning_files: this.planning_files_attachments,
      free_text: data.planning_confirm_transport_free_text,
      additional_recipients: data.planning_confirm_transport_additional_recipients
    };

    this.planningConfirmTransportService.sendPlanningConfirmTransport(body).subscribe(
      (res: any) => {
        //console.log("this.planningConfirmTransportService.sendPlanningConfirmTransport response:", res);
        this.toast.success(`Le transport a été confirmé avec succès`, false, "Confirmer le transport");
        this.updatePlanningState.emit({ planning_id: this.planning_id, state: res.state}); // Update planning state in list
        this.sendConfirmTransportLoading = false;
        this.closeModal();
      },
      (error) => {
        console.log("this.planningConfirmTransportService.sendPlanningConfirmTransport error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la confirmation du transport.`,
          false,
          "Confirmer le transport"
        );
        this.sendConfirmTransportLoading = false;
      }
    );
  }

  openPlanningFile(planning_file) {
    const API_URI = this.planningFilesService.getApiURI();
    window.open(`${API_URI}/${planning_file.filename}`);
  }

  // Reset planningConfirmTransport data/inputs
  resetPlanningConfirmTransportData() {
    this.confirm_transport_form.get('planning_confirm_transport_free_text').reset();
    this.confirm_transport_form.get('planning_confirm_transport_additional_recipients').reset();
    this.planning_files = null;
    this.planning_files_attachments= [];
    this.sendConfirmTransportLoading = false;
  }

  // Open modal
  openModal(planning_id: number) {
    this.planning_id = planning_id;
    this.resetPlanningConfirmTransportData();
    this.getPlanningFiles(this.planning_id);
    jQuery('#planning_confirm_transport_modal').modal('show', { centered: true });
  }

  // Close modal
  closeModal() {
    jQuery('#planning_confirm_transport_modal').modal('hide');
  }

  isValidMail(value: string) {
    const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return expression.test(String(value).toLowerCase())
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/client/client-planning-confirm-transport-modal/client-planning-confirm-transport-modal.component.ts